import { useEffect, useState } from 'react';

import { isAndroid, isIOS } from '@whelk/utils';

export const useKeyboardHeight = () => {
  const [keyboardHeight, setKeyboardHeight] = useState(0);
  const [visualViewport, setVisualViewport] = useState(window.innerHeight);
  // // 禁止滚动
  // function disableScroll() {
  //   document.body.style.overflow = 'hidden';
  // }

  // 启用滚动
  function enableScroll() {
    document.body.style.overflow = '';
  }

  const scrollToView = () => {
    // 小程序首次进入时，输入框不会自动滚动到底部，需要手动滚动
    const inputField = document.getElementById('chat-input-box');
    if (inputField) {
      setTimeout(() => {
        inputField.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 350); // 延迟200毫秒，以确保在键盘完全弹出后滚动
    }
  };

  useEffect(() => {
    const handleResize = () => {
      const windowHeight = window?.visualViewport?.height || window.innerHeight;
      if (windowHeight < initialWindowHeight) {
        setKeyboardHeight(initialWindowHeight - windowHeight);
        setVisualViewport(windowHeight);
        scrollToView();
      } else {
        setKeyboardHeight(0);
        setVisualViewport(windowHeight);
      }
    };

    const handleFocus = () => {
      setTimeout(() => {
        const windowHeight = window?.visualViewport?.height || window.innerHeight;
        if (windowHeight !== keyboardHeight) {
          setKeyboardHeight(initialWindowHeight - windowHeight);
          setVisualViewport(windowHeight);
        }
      }, 300);
    };

    const handleBlur = () => {
      // iOS 上，键盘收起时，input 会失去焦点
      setKeyboardHeight(0);
      enableScroll();
    };

    const initialWindowHeight = window.innerHeight;
    if (isAndroid) {
      // 安卓设备
      window.addEventListener('resize', handleResize);
    } else if (isIOS) {
      // iOS 设备
      const input = document.querySelector<HTMLTextAreaElement>('#chat-input');
      input?.addEventListener('focus', handleFocus);
      input?.addEventListener('blur', handleBlur);
      // window.addEventListener('resize', handleResize);
      return () => {
        input?.removeEventListener('focus', handleFocus);
        input?.removeEventListener('blur', handleBlur);
      };
    }

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return {
    keyboardHeight: keyboardHeight,
    visualViewport: visualViewport,
  };
};
